import { viteEnvSchema } from './lib/types/env';

export const ViteEnv = viteEnvSchema.parse(import.meta.env);
